import { Component, OnInit ,ElementRef ,ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../../services/brdsql.service';
import * as XLSX from 'xlsx'; 

@Component({
  selector: 'app-emp-dep',
  templateUrl: './emp-dep.component.html',
  styleUrls: ['./emp-dep.component.css']
})
export class EmpDepComponent implements OnInit {

  depData?:any = [];
  partData?:any = [];
  factionData?:any = [];
  @ViewChild('tb_data') tb_data!: ElementRef;
  formEdit = false;
  depEdit?:any = [];
  fileName= 'ExcelDownload.xlsx'; 

  constructor(
    private brdservice: BrdsqlService,
  ) { }

  ngOnInit(): void {
    this.depList();
    this.partList();
    this.factionList();
  }

  async depList() {
    this.depData = [];
    await this.brdservice.departmentList()
    .subscribe({
      next: (data:any) => {
        this.depData = data.recordset;
        setTimeout(() => {
          $(this.tb_data.nativeElement).DataTable();
        }, 0);
      }
    })
  }

  async partList() {
    this.partData = [];
    await this.brdservice.brdpartList()
    .subscribe({
      next: (data:any) => {
        this.partData = data.recordset;
      }
    })
  }

  async factionList() {
    this.factionData = [];
    await this.brdservice.brdfactionList()
    .subscribe({
      next: (data:any) => {
        this.factionData = data.recordset;
      }
    })
  }  

  // บันทึกการเพิ่มข้อมูลแผนก
  saveAddDep(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveAddBrdDep(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.depList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  // บันทึกการแก้ไขข้อมูลแผนก
  saveEditDep(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.updateDepartment(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.depList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };
  
  editDep(dataid:string) {
    this.formEdit = true;  // สถานะเป็นฟอร์มแก้ไข
    this.depEdit = this.depData.filter((el: { dataid: any; }) => el.dataid == dataid);
    this.depEdit = this.depEdit[0];
    // console.log('depEdit ' ,this.depEdit);
  }

  formReset() {
    this.formEdit = false;
  }

  exportDep(): void {
    {
      /* table id is passed over here */   
      let element = document.getElementById('dep-table'); 
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, this.fileName);
     
   }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }  
}
